import { Link } from 'react-router-dom';
import { Settings, User } from 'lucide-react';

interface TopBarProps {
  userName?: string;
  onLogout?: () => void | Promise<void>;
}

const today = () => {
  const text = new Date().toLocaleDateString('sv-SE', { weekday: 'long', day: 'numeric', month: 'long' });
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export default function TopBar({ userName }: TopBarProps) {
  return (
    <header className="sticky top-3 z-20 mx-6 mt-3 lg:mx-10">
      <div className="flex items-center justify-between gap-4 rounded-full bg-white/70 py-1.5 pl-5 pr-1.5 shadow-[0_18px_40px_-28px_rgb(0_22_49_/_0.45)] ring-1 ring-gray-200/80 backdrop-blur-xl">
        <p className="flex items-center gap-2.5 text-[13px] text-gray-500">
          <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-[#16acce] shadow-[0_0_0_4px_rgb(22_172_206_/_0.15)]" />
          {today()}
        </p>

        <Link
          to="/settings"
          title="Inställningar"
          className="group flex items-center gap-2.5 rounded-full bg-gray-50 py-1 pl-1 pr-3 text-[13px] text-gray-700 ring-1 ring-inset ring-gray-200/70 transition-all duration-300 ease-fluid hover:bg-white hover:ring-blue-200 active:scale-[0.98]"
        >
          <span className="flex h-7 w-7 items-center justify-center rounded-full bg-navy text-[#5ac9e3]">
            <User className="h-3.5 w-3.5" aria-hidden />
          </span>
          <span className="font-medium">{userName || 'Användare'}</span>
          <Settings className="h-3.5 w-3.5 text-gray-400 transition-transform duration-500 ease-fluid group-hover:rotate-45 group-hover:text-blue-600" aria-hidden />
          <span className="sr-only">– inställningar</span>
        </Link>
      </div>
    </header>
  );
}
